import React, { Component } from "react";
import ListingPage from "../2/Controls/ListingPage";
import Input from "../2/Controls/Input";
import Window from "../2/Controls/Window";
import ExportButton from "../2/Controls/ExportButton";
import { exportFile } from "../../actions/DataExporter";
import ImportLog from "../ImportLog";
import ImportData from "../ImportData";
import Button from "../2/Controls/Button";
import CategoryList from "./CategoryList"
import { currenySymbol } from "../../actions/Util";
import ViewProduct from "./ViewProductDetail/ViewProduct";
class ProductList extends Component {

  constructor(props) {

    super(props);

    this.state = {

      list: [],
      totalCount: 0,
      loading: false,

      page: 1,
      pageSize: 25,

      searchParam: "",
      filter: {


        productType: "",
        name: "",
        sku: "",
        barCode: "",
        category: "",
        subCategory: "",
        brand: "",
        status: "active"

      },

      showFilter: false,
      showOption: false,
      showImportLog: false,
      showImport: false,
      showDelete: false,

      selectedRow: null,

      isFilterActive: false,

      listPageSettings: {

        Title: "Products",

        Search: {

          showSearch: true,
          placeholder: "Search product by SKU, barcode or name",

          onSearch: this.onSearch,

          onRefresh: this.onRefreshClick,

          onFilterClick: () =>
            this.setState({ showFilter: true }),

          isFilterActive: false

        },

        HeaderButtons: [

          {
            ButtonType: "Button",
            Type: "primary",
            Text: "New",
            Icon: "add",
            Action: "new",
            showInCompact: true,

          },

          {
            ButtonType: "ImageButton",
            Type: "option",
            Text: "Options",
            Icon: "option",
            Action: "options",
            showInCompact: true,
          }

        ],

        Columns: [
          {
            Name: "",
            Type: "field",
            Columns: [{ Column: "Images[0].ImagePath", Type: "image" }],
          },
          {
            Name: "Type",
            Type: "multiple",
            Columns: [{ Column: "ProductType" }, { Column: "InventoryType" }],
          },
          {
            Name: "SKU",
            Type: "multiple",
            Columns: [
              { Column: "SKU" },
              {
                Column: "BarCode",
                Type: "custom",
                renderCell: ({ row }) => (
                  <div>
                    {Array.isArray(row.BarCode)
                      ? row.BarCode.join(", ")
                      : row.BarCode}
                  </div>
                ),
              },
            ],
          },
          {
            Name: "Name",
            Type: "multiple",
            Columns: [{ Column: "Name" }, { Column: "Description" }],
          },
          {
            Name: "Category",
            Type: "field",
            Columns: [{ Column: "Category" }],
          },
          {
            Name: "Sub Category",
            Type: "field",
            Columns: [{ Column: "SubCategory" }],
          },
          {
            Name: "Supply Price",
            Type: "field",
            Columns: [{ Column: "SupplyPrice", Type: "number" }],
          },
          {
            Name: "Retail Price",
            Type: "field",
            Columns: [{ Column: "RetailPrice", Type: "number" }],
          },
          {
            Name: "Discount",
            Type: "field",
            Columns: [{ Column: "DiscountAmount", Type: "number" }],
          },
          {
            Name: "MRP",
            Type: "field",
            Columns: [{ Column: "MRP", Type: "number" }],
          },
          ...(this.props.registration.registration.hasOwnProperty("OMNIEnabled") ? [{
            Name: "Show Online",
            Type: "field",
            Columns: [{ Column: "OMNIEnabled", Type: "yesno" }],
          }] : []),
          {
            Name: "Instock",
            Column: "Instock",
            Type: "custom",
            renderCell: ({ row }) => {
              return (
                <div style={{ textAlign: "right" }}>
                  {[3, 4, 5].includes(row.ProductTypeID) ? "-" : row.InStockQty}
                </div>
              );
            },
          },
          {
            Name: "",
            Type: "field",
            ShowInMobile: true,
            Columns: [
              { Column: "Name", CSS: "main" },
              { Column: "SKU" },
              {
                Column: "BarCode",
                Type: "custom",
                renderCell: ({ row }) => (
                  <div>
                    {Array.isArray(row.BarCode)
                      ? row.BarCode.join(", ")
                      : row.BarCode}
                  </div>
                ),
              },
              { Column: "ProductType" },
              { Column: "RetailPrice", Label: "Retail price" },
              { Column: "OMNIEnabled", Type: "yesno", Label: "Show online" },
            ],
          },
        ],

        RowButtons: [
        ]

      }

    };

  }

  componentDidMount() {
    console.log("WhatsappActiveProvider",this.props.config.WhatsappActiveProvider);
    let saved = this.props.getPageFilters("ProductList");

    let page = 1;
    let pageSize = 25;
    let searchParam = "";
    let isFilterActive = false;
    let filter = { ...this.state.filter };



    if (saved) {
      console.log("saved", saved);
      filter = saved.PageFilters || filter;
      searchParam = saved.SearchText || "";
      page = saved.ActivePage || 1;
      isFilterActive = saved.IsFilterActive;
      if (saved.RecordFrom) {
        page = Math.floor(saved.RecordFrom / pageSize) + 1;
      }
    }

    this.setState(
      {
        filter: {
          ...filter
        },
        isFilterActive: isFilterActive,
        searchParam: searchParam,
        page,
      },
      () => {
        this.loadData();
      }
    );

  }

  // =====================
  // LOAD DATA
  // =====================

  loadData = async () => {

    this.setState({ loading: true });

    try {

      const { page, pageSize, filter, searchParam } =
        this.state;

      const res =

        await this.props.getProducts(
          (page - 1) * pageSize,          // from
          pageSize,                       // size
          filter.status || "active",      // status
          searchParam,                    // searchParam
          filter.productType,             // productType
          filter.name,                    // name
          filter.sku,                     // sku
          filter.barCode,                 // barCode
          filter.category,                // category
          filter.subCategory,             // subCategory
          filter.brand,                   // brand
          this.props.user.store.key,
          null,                           // psin
          null,                           // globalCatalogue
          true,                           // excludeChildProduct
          false

        );
      let list = [];
      let totalCount = 0;

      if (
        res &&
        res.hasOwnProperty("products")
      ) {
        list = res.products;
      }

      if (
        res &&
        res.hasOwnProperty("totalCount")
      ) {
        totalCount = res.totalCount;
      }

      this.setState({

        list: list,

        totalCount: totalCount,

        loading: false

      });

    }

    catch (error) {

      console.error(error);

      this.setState({
        loading: false
      });

    }

  };

  // =====================
  // SEARCH
  // =====================


  onSearch = (text) => {
    this.setState({ searchParam: text, page: 1 }, () => {
      this.savePageFilters();
      this.loadData();
    });
  };

  onRefreshClick = () => {
    this.setState(
      {
        filter: {
          productType: "",
          name: "",
          sku: "",
          barCode: "",
          category: "",
          subCategory: "",
          brand: "",
          status: "active"
        },
        page: 1,
        isFilterActive: false,
        searchParam: "",
      },
      () => {
        this.savePageFilters();
        this.loadData();
      }
    );
  };


  // =====================
  // PAGINATION
  // =====================

  onNextClick = () => {

    const totalPages = Math.ceil(

      this.state.totalCount /
      this.state.pageSize

    );

    if (this.state.page < totalPages) {

      this.setState({

        page:
          this.state.page + 1

      },

        this.loadData

      );

    }

  };

  onPreviousClick = () => {

    if (this.state.page > 1) {

      this.setState({

        page:
          this.state.page - 1

      },

        this.loadData

      );

    }

  };

  onFirstClick = () => {

    this.setState({

      page: 1

    },

      this.loadData

    );

  };

  onLastClick = () => {

    const totalPages = Math.ceil(

      this.state.totalCount /
      this.state.pageSize

    );

    this.setState({

      page: totalPages

    },

      this.loadData

    );

  };

  onRecordsPerPageCountChange =
    (size) => {

      this.setState({

        pageSize: Number(size),

        page: 1

      },

        this.loadData

      );

    };

  // =====================
  // HEADER BUTTON
  // =====================

  onHeaderButtonClicked = (btn) => {

    if (btn.Action === "new") {

      this.props.history.push(
        "/home/product/newproduct"
      );

    }

    if (btn.Action === "options") {

      this.setState({

        showOption: true

      });

    }

  };

  // =====================
  // FILTER
  // =====================
  onApplyFilter = () => {
    this.setState(
      { page: 1, showFilter: false, isFilterActive: true },
      () => {
        this.savePageFilters();
        this.loadData();
      }
    );
  };


  onClearFilter = () => {

    this.onRefreshClick();

    this.setState({

      showFilter: false

    });

  };

  // =====================
  // DELETE
  // =====================

  onRowButtonClicked = (btn, row) => {

    if (btn.Type === "edit") {

      this.props.history.push(
        "/home/product/edit/" + row.key
      );

    }

    if (btn.Type === "delete") {

      this.setState({

        showDelete: true,

        selectedRow: row

      });

    }

  };

  deleteRecord = async () => {

    await this.props.deleteProduct(

      this.state.selectedRow.key

    );

    this.setState({

      showDelete: false,

      selectedRow: null

    },

      this.loadData

    );

  };

  // =====================
  // EXPORT
  // =====================

  getExportData = async () => {


    try {
      let allProducts = [];
      let hasMore = true;

      let pitId = null;
      let searchAfter = null;

      const size = 2000;

      const filter = this.state.filter;

      let storeID = null;


      storeID = this.props.user.store.key;

      while (hasMore) {
        const response = await this.props.getProductsForExport({
          searchParam: this.state.searchParam,

          from: null,
          size: size,


          productType:
            filter.productType === "All"
              ? ""
              : filter.productType,

          name: filter.name,
          sku: filter.sku,
          barCode: filter.barCode,
          category: filter.category,
          subCategory: filter.subCategory,
          brand: filter.brand,
          status: filter.status,

          storeID: storeID,

          excludeChildProduct: false,

          storeSpecificPrices: false,

          pitId: pitId,

          searchAfter: searchAfter
        });

        if (response.code !== "0") break;


        allProducts.push(...response.products);

        // console.log("response ✅", response);


        pitId = response.pitId; // Update PIT for next request
        searchAfter = JSON.stringify(response.lastSort); // Update search_after for next request
        hasMore = response.hasMore;

        // Process products: apply store pricing etc.

      }


      const updatedProducts = allProducts.map(row => {
        if ([3, 4, 5].includes(row.ProductTypeID)) {
          return { ...row, InStockQty: "-" };
        }
        return row;
      });

      return updatedProducts;

    } catch (err) {
      console.error("Error fetching product:", err);
      return [];
    } finally {
    }
  };


  handleExport = async (type) => {
    this.setState({ loading: true });
    try {

      const data =
        await this.getExportData();

      if (!data.length) {

        alert("No data found");

        return;

      }

      let customField1DisplayName = "";
      let customField2DisplayName = "";
      let customField3DisplayName = "";
      let customField4DisplayName = "";
      let customField5DisplayName = "";
      let customField6DisplayName = "";

      this.props.config.CustomFields.map((customField) => {
        if (customField.ModuleName === "Product") {
          customField1DisplayName =
            customField.CustomField1Name.trim() === ""
              ? "Custom Field 1"
              : customField.CustomField1Name.trim();
          customField2DisplayName =
            customField.CustomField2Name.trim() === ""
              ? "Custom Field 2"
              : customField.CustomField2Name.trim();
          customField3DisplayName =
            customField.CustomField3Name.trim() === ""
              ? "Custom Field 3"
              : customField.CustomField3Name.trim();
          customField4DisplayName =
            customField.CustomField4Name.trim() === ""
              ? "Custom Field 4"
              : customField.CustomField4Name.trim();
          customField5DisplayName =
            customField.CustomField5Name.trim() === ""
              ? "Custom Field 5"
              : customField.CustomField5Name.trim();
          customField6DisplayName =
            customField.CustomField6Name.trim() === ""
              ? "Custom Field 6"
              : customField.CustomField6Name.trim();
        }
      });

      const columns = [
        { header: "ProductType", field: "ProductType", type: "text" },
        { header: "SKU", field: "SKU", type: "text" },
        {
          header: "BarCode",
          field: "BarCode",
          type: "text",
          formatter: (v) => (Array.isArray(v) ? v.join(", ") : v),
        },
        { header: "Brand", field: "Brand", type: "text" },
        { header: "Category", field: "Category", type: "text" },
        { header: "SubCategory", field: "SubCategory", type: "text" },
        { header: "Name", field: "Name", type: "text" },
        { header: "Description", field: "Description", type: "text" },
        { header: "HSNSACCode", field: "HSNSACCode", type: "text" },

        { header: "ChargeTaxOnProduct", field: "ChargeTaxOnProduct", type: "boolean" },

        { header: "MRP", field: "MRP", type: "number" },
        { header: "SupplyPrice", field: "SupplyPrice", type: "number" },
        { header: "RetailPrice", field: "RetailPrice", type: "number" },
        { header: "Markup", field: "Markup", type: "number" },
        { header: "DiscountPercentage", field: "DiscountPercentage", type: "number" },
        { header: "DiscountAmount", field: "DiscountAmount", type: "number" },

        { header: "TaxInclusive", field: "TaxInclusive", type: "boolean" },
        { header: "TaxInclusivePurchase", field: "TaxInclusivePurchase", type: "boolean" },

        { header: "TaxGroup", field: "TaxGroup", type: "text" },

        { header: "PriceBasedTax", field: "PriceBasedTax", type: "boolean" },

        { header: "PriceRangeFrom1", field: "PriceRangeFrom1", type: "number" },
        { header: "PriceRangeTo1", field: "PriceRangeTo1", type: "number" },
        { header: "TaxGroup1", field: "TaxGroup1", type: "text" },

        { header: "PriceRangeFrom2", field: "PriceRangeFrom2", type: "number" },
        { header: "PriceRangeTo2", field: "PriceRangeTo2", type: "number" },
        { header: "TaxGroup2", field: "TaxGroup2", type: "text" },

        { header: "InventoryType", field: "InventoryType", type: "text" },

        { header: "RepackProduce", field: "RepackProduce", type: "boolean" },

        { header: "MinQty", field: "MinQty", type: "number" },
        { header: "MaxQty", field: "MaxQty", type: "number" },
        { header: "ReorderQty", field: "ReorderQty", type: "number" },

        { header: "UniqueNoLabel", field: "UniqueNoLabel", type: "text" },
        { header: "NoOfUniqueNoPerItem", field: "NoOfUniqueNoPerItem", type: "text" },

        { header: "AllowDiscount", field: "AllowDiscount", type: "boolean" },
        { header: "AllowPriceEdit", field: "AllowPriceEdit", type: "boolean" },
        { header: "AllowTaxChange", field: "AllowTaxChange", type: "boolean" },

        { header: "WalletTopUpAmount", field: "WalletTopUpAmount", type: "number" },

        { header: "WalletTopUpSameAsRetailPrice", field: "WalletTopUpSameAsRetailPrice", type: "boolean" },

        { header: "AllowUserToSpecifyRechargeAmountAtTimeOfBilling", field: "AllowUserToSpecifyRechargeAmountAtTimeOfBilling", type: "boolean" },

        { header: customField1DisplayName, field: "CustomField1", type: "text" },
        { header: customField2DisplayName, field: "CustomField2", type: "text" },
        { header: customField3DisplayName, field: "CustomField3", type: "text" },
        { header: customField4DisplayName, field: "CustomField4", type: "text" },
        { header: customField5DisplayName, field: "CustomField5", type: "text" },
        { header: customField6DisplayName, field: "CustomField6", type: "text" },

        { header: "UOM", field: "UOM", type: "text" },
        { header: "SecondaryUOM", field: "SecondaryUOM", type: "text" },

        { header: "UOMToSecondaryUOMConversion", field: "UOMToSecondaryUOMConversion", type: "text" },

        { header: "SalesUOM", field: "SalesUOM", type: "text" },
        { header: "PurchaseUOM", field: "PurchaseUOM", type: "text" },

        { header: "PromptForQty", field: "PromptForQty", type: "boolean" },
        { header: "Favourite", field: "Favourite", type: "boolean" },

        { header: "ShowOnline", field: "OMNIEnabled", type: "boolean" },

        { header: "BOM", field: "BOM", type: "boolean" },

        { header: "BOMManual", field: "ManuallySpecifyProductConsumption", type: "boolean" },

        { header: "CanBeUsedAsConsumable", field: "CanBeUsedAsConsumable", type: "boolean" },

        { header: "AssociateMembership", field: "AssociateMembership", type: "boolean" },

        { header: "Membership", field: "Membership", type: "text" },

        { header: "BatchTrackingBatchNoRequired", field: "BatchTrackingBatchNoRequired", type: "boolean" },
        { header: "BatchTrackingMRPRequired", field: "BatchTrackingMRPRequired", type: "boolean" },
        { header: "BatchTrackingMfgDateRequired", field: "BatchTrackingMfgDateRequired", type: "boolean" },
        { header: "BatchTrackingExpDateRequired", field: "BatchTrackingExpDateRequired", type: "boolean" },

        { header: "BatchTrackingDateFormat", field: "BatchTrackingDateFormat", type: "text" },

        { header: "ParentSKU", field: "ParentSKU", type: "text" },

        { header: "VariantOptionOneName", field: "VariantOptionOneName", type: "text" },
        { header: "VariantOptionOneValue", field: "VariantOptionOneValue", type: "text" },

        { header: "VariantOptionTwoName", field: "VariantOptionTwoName", type: "text" },
        { header: "VariantOptionTwoValue", field: "VariantOptionTwoValue", type: "text" },

        { header: "VariantOptionThreeName", field: "VariantOptionThreeName", type: "text" },
        { header: "VariantOptionThreeValue", field: "VariantOptionThreeValue", type: "text" },

        { header: "InStock", field: "InStockQty", type: "text" },
        { header: "ProductID", field: "key", type: "text" },

        { header: "SecondaryUOMs", field: "SecondaryUOMs", type: "text" }
      ];

      await exportFile({

        data: data,

        columns: columns,

        fileType: type,

        title: "Products",

        landscape: true

      });

    }

    catch (error) {
      this.setState({ loading: false });
      console.error(error);

      alert("Export failed");

    }
    finally {
      this.setState({ loading: false });
    }

  };

  onImport = () => {

    this.setState({

      showImport: true,
      showOption: false

    });

  };
  onImportLog = () => {

    this.setState({

      showImportLog: true,
      showOption: false

    });

  };

  // =====================
  // RENDER
  // =====================

  onPageChange = (page, pageSize) => {
    console.log("page", page);
    this.setState(
      { page, pageSize },
      () => {
        this.savePageFilters();
        this.loadData();
      }
    );
  };


  savePageFilters = () => {
    const { filter, searchParam, page, pageSize, isFilterActive } = this.state;
    console.log("418 saving page filters");
    this.props.setPageFilters(
      "ProductList",
      filter,
      searchParam,
      (page - 1) * pageSize, // recordFrom
      page,
      isFilterActive
    );
  };
  compressTableColumns = [
    {
      Name: "Product Details",  // Changed from headerName
      Type: "custom",            // Added Type
      field: "productDetails",   // Keep your field
      flex: 1,
      hideHeaderNameOnMobile: true,
      renderCell: (row) => {
        const truncateText = (text, prefix = "", type) => {
          if (!text && text !== 0) return "";

          let displayText;

          if (type === "currency") {
            const numericValue = Number(text);

            if (isNaN(numericValue)) return "";

            displayText = prefix
              ? `${prefix}: ${currenySymbol()}${numericValue}`
              : `${currenySymbol()}${numericValue}`;
          } else {
            displayText = prefix
              ? `${prefix}: ${text}`
              : text.toString();
          }

          return displayText.length > 35
            ? `${displayText.substring(0, 35)}...`
            : displayText;
        };

        const hasValue = (value) => {
          return value !== null && value !== undefined && value !== "";
        };

        let imagePath = null;

        if (
          row.row.hasOwnProperty("Images") &&
          row.row.Images !== null &&
          row.row.Images.length > 0 &&
          row.row.Images[0].hasOwnProperty("ImagePath")
        ) {
          imagePath = row.row.Images[0].ImagePath;
        }

        let productName = "";

        if (
          row.row.hasOwnProperty("Name") &&
          row.row.Name !== null
        ) {
          productName = row.row.Name;
        }

        let firstChar = "";

        if (productName.length > 0) {
          firstChar = productName[0];
        }

        let barCode = "";

        if (
          row.row.hasOwnProperty("BarCode") &&
          row.row.BarCode !== null
        ) {
          barCode = row.row.BarCode;
        }

        let sku = "";

        if (
          row.row.hasOwnProperty("SKU") &&
          row.row.SKU !== null
        ) {
          sku = row.row.SKU;
        }

        let pincodeProductID = "";

        if (
          row.row.hasOwnProperty("PincodeProductID") &&
          row.row.PincodeProductID !== null
        ) {
          pincodeProductID = row.row.PincodeProductID;
        }

        let retailPrice = null;

        if (
          row.row.hasOwnProperty("RetailPrice") &&
          row.row.RetailPrice !== null
        ) {
          retailPrice = row.row.RetailPrice;
        }

        let mrp = null;

        if (
          row.row.hasOwnProperty("MRP") &&
          row.row.MRP !== null
        ) {
          mrp = row.row.MRP;
        }

        return (
          <div
            style={{
              display: "flex",
              gap: "16px",
              alignItems: "flex-start",
              width: "100%",
              minWidth: 0,
              paddingRight: "16px"
            }}
          >
            {imagePath ? (
              <img
                src={imagePath}
                alt={productName || "Product Image"}
                style={{
                  width: "56px",
                  height: "56px",
                  flexShrink: 0,
                  objectFit: "cover",
                  borderRadius: "8px"
                }}
              />
            ) : (
              <div
                style={{
                  width: "56px",
                  height: "56px",
                  flexShrink: 0,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "24px",
                  backgroundColor: "var(--secondary-btn-clr)",
                  borderRadius: "8px",
                  textTransform: "capitalize"
                }}
              >
                {firstChar || "?"}
              </div>
            )}

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                flexGrow: 1,
                minWidth: 0
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  minWidth: 0
                }}
              >
                <span
                  style={{
                    color: "#000000",
                    fontWeight: 600
                  }}
                  title={productName}
                >
                  {truncateText(productName)}
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "4px",
                  width: "100%",
                  minWidth: 0,
                  paddingRight: "8px",
                  color: "var(--tab-gray, #6b7280)"
                }}
              >
                {barCode ? (
                  <div>{truncateText(barCode)}</div>
                ) : null}

                {sku ? (
                  <div title={sku}>
                    {truncateText(sku)}
                  </div>
                ) : null}

                {pincodeProductID ? (
                  <div title={pincodeProductID}>
                    {truncateText(pincodeProductID)}
                  </div>
                ) : null}

                {hasValue(retailPrice) ? (
                  <div>
                    {truncateText(
                      retailPrice,
                      "Retail Price",
                      "currency"
                    )}
                  </div>
                ) : null}

                {hasValue(mrp) ? (
                  <div>
                    {truncateText(
                      mrp,
                      "MRP",
                      "currency"
                    )}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        );
      },
    }
  ];
  render() {

    return (

      <>

        <ListingPage
          {...this.props}
          listPageSettings={this.state.listPageSettings}
          list={this.state.list}
          loading={this.state.loading}

          compactTableColumns={this.compressTableColumns}
          hideTableHeaderInCompact={true}

          // New props for side-by-side layout
          enableSideBySide={true}
          renderSideBySide={(rowData, onClose) => (
            <ViewProduct
              {...this.props}
              product={rowData}  // Pass the actual product data from the row
              isAllowUpdate={this.props.getVisibility("Products", "update")}
              isAllowDelete={this.props.getVisibility("Products", "delete")}
              handleEditBtnClick={() => {
                this.props.history.push("/home/product/edit/" + rowData.key);
              }}
              handleDeleteBtnClick={() => {
                this.setState({
                  showDelete: true,
                  selectedRow: rowData
                });
              }}
              onClose={onClose}
            />
          )}
          onRefreshData={this.loadData} // Callback to refresh list after update
          onPageChange={this.onPageChange}
          onRowClick={null} // Not needed when using side-by-side

          // Other existing props...
          totalItemsCount={this.state.totalCount}
          recordFrom={(this.state.page - 1) * this.state.pageSize}
          itemsCountPerPage={this.state.pageSize}
          onNextClick={this.onNextClick}
          onPreviousClick={this.onPreviousClick}
          onFirstClick={this.onFirstClick}
          onLastClick={this.onLastClick}
          onRecordsPerPageCountChange={this.onRecordsPerPageCountChange}
          onHeaderButtonClicked={this.onHeaderButtonClicked}
          onRowButtonClicked={this.onRowButtonClicked}
          searchText={this.state.searchParam}
        />

        {this.state.showFilter && (

          <Window

            header="Filter"

            size="small"

            slide

            onClose={() =>
              this.setState({
                showFilter: false
              })
            }

            onButtonClick={(action) => {

              if (
                action.toLowerCase() === "apply"
              ) {

                this.onApplyFilter();

              }

              else if (
                action.toLowerCase() === "clear"
              ) {

                this.onClearFilter();

              }

            }}

            buttons={[
              {
                Type: "secondary",
                Text: "Clear",
                Align: "left"
              },
              {
                Type: "primary",
                Text: "Apply",
                Align: "right"
              }

            ]}
          >

            <Input
              type="select"
              label="Product Type"
              value={this.state.filter.productType}
              onChange={(v) =>
                this.setState({

                  filter: {
                    ...this.state.filter,
                    productType: v
                  }

                })
              }
            >

              <option value="">All</option>

              <option value="Goods for sale">
                Goods for sale
              </option>

              <option value="Goods not for sale">
                Goods not for sale
              </option>

              <option value="Services">
                Services
              </option>

              <option value="Wallet Recharge">
                Wallet Recharge
              </option>

              <option value="Package">
                Package
              </option>

            </Input>

            <Input
              type="text"
              label="Name"
              value={this.state.filter.name}
              onChange={(v) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    name: v
                  }
                })
              }
            />

            <Input
              type="text"
              label="SKU"
              value={this.state.filter.sku}
              onChange={(v) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    sku: v
                  }
                })
              }
            />

            <Input
              type="text"
              label="Barcode"
              value={this.state.filter.barCode}
              onChange={(v) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    barCode: v
                  }
                })
              }
            />

            <Input
              type="text"
              label="Category"
              value={this.state.filter.category}
              onChange={(v) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    category: v
                  }
                })
              }
            />

            <Input
              type="text"
              label="SubCategory"
              value={this.state.filter.subCategory}
              onChange={(v) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    subCategory: v
                  }
                })
              }
            />

            <Input
              type="text"
              label="Brand"
              value={this.state.filter.brand}
              onChange={(v) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    brand: v
                  }
                })
              }
            />

            <Input
              type="select"
              label="Status"
              value={this.state.filter.status}
              onChange={(v) =>
                this.setState({
                  filter: {
                    ...this.state.filter,
                    status: v
                  }
                })
              }
            >

              <option value="active">
                Active
              </option>

              <option value="inActive">
                Inactive
              </option>

              <option value="all">
                All
              </option>

            </Input>

          </Window>

        )}

        {this.state.showOption && (

          <Window
            header="Options" choiceList
            size="small"
            slide
            onClose={() =>
              this.setState({
                showOption: false
              })
            }
          >

            {(this.props.user.user.Role === "Power User" ||
              this.props.user.user.Role === "Store Owner") && (

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",      // 👈 horizontal layout
                    gap: 10,
                    justifyContent: "center",  // 👈 center horizontally
                    alignItems: "center",      // 👈 align vertically
                    flexWrap: "wrap"           // optional: moves to next line on small screens
                  }}
                >
                  {this.props.user.store &&
                    this.props.user.store.hasOwnProperty("NoOfDaysToExpire") &&
                    this.props.user.store.NoOfDaysToExpire > 15 && (

                      <ExportButton
                        onExport={this.handleExport}
                        loading={this.state.loading}
                      />

                    )}

                  <Button
                    type="secondary"
                    text="Product Import"
                    onClick={this.onImport}
                  />

                  <Button
                    type="secondary"
                    text="Product Import Log"
                    onClick={this.onImportLog}
                  />

                  <Button
                    type="secondary"
                    text="Quick Edit"
                    onClick={() => {
                      this.props.history.push("/home/product/quickedit/");
                    }}
                  />

                  <Button
                    type="secondary"
                    text="Barcode Print"
                    onClick={() => {
                      this.props.history.push({
                        pathname: "/home/barcodeprint/",
                        state: {
                          data: null,
                          transactionType: "master",
                        },
                      });
                    }}
                  />
                </div>
              )}
          </Window>

        )}

        {this.state.showDelete && (

          <Window

            header="Delete"

            modal

            onClose={() =>
              this.setState({
                showDelete: false
              })
            }

            onButtonClick={(btn) => {

              if (btn === "Yes")
                this.deleteRecord();

              else
                this.setState({
                  showDelete: false
                });

            }}

            buttons={[
              {
                Type: "secondary",
                Text: "No",
                Align: "left"
              },
              {
                Type: "primary",
                Text: "Yes",
                Align: "right"
              }

            ]}

          >

            Are you sure you want to delete?

          </Window>

        )}

        {this.state.showImport && (

          <ImportData

            {...this.props}

            importType="product"
            slide={true}
            onClose={() =>
              this.setState({
                showImport: false
              })
            }

            onImportCompleted={() =>
              this.loadData()
            }

          />

        )}

        {/* IMPORT LOG */}

        {this.state.showImportLog && (

          <ImportLog

            {...this.props}

            importType="product"
            slide={true}

            onClose={() =>
              this.setState({
                showImportLog: false
              })
            }

          />

        )}

      </>

    );

  }

}

export default ProductList;